// extracted by mini-css-extract-plugin
export default {"message":"E9crwx","title":"cdXFq0","description":"anODk_"};